module.exports = __webpack_public_path__ + "static/img/hy_v1.9438dcae.png";